import React from "react";
import { ThinTextField, ThinTextAreaField } from "../../common/GeneralComponent";

const SummaryFollowup = ({ data }) => {
  if (!data) {
    return (
      <div className="text-center py-8 text-gray-500">No data available</div>
    );
  }

  const overallObservation = data.overall_observation || "N/A";
  const immediateFollowUp = data.immediate_follow_up || "N/A";
  const followUpDetails = data.immediate_follow_up_specify || "N/A";

  return (
    <div className="bg-white rounded p-4">
      <form className="w-full">
        {/* First Row - Overall Observation (Full Width) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="w-full md:col-span-3">
            <ThinTextAreaField
              isRequired={false}
              label="Overall observation / finding"
              value={overallObservation}
              disabled
            />
          </div>
        </div>

        {/* Second Row - Immediate Follow-up, Empty, Empty */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Immediate follow-up required?"
            value={immediateFollowUp}
            disabled
          />
          <div className="w-full"></div>
          <div className="w-full"></div>
        </div>

        {/* Third Row - Follow-up Details (Full Width) - Only show if Yes */}
        {immediateFollowUp === "Yes" && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="w-full md:col-span-3">
              <ThinTextAreaField
                isRequired={false}
                label="If Yes, describe the action needed and responsible person/team"
                value={followUpDetails}
                disabled
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default SummaryFollowup;